import React from 'react';
import ACTIONS from '~shared/actions';
import { PackageIds, Packages } from '~shared/constants/pricing';
import { CombinedActions } from '~shared/types/pricing/actions';
import IncludedLink from './components/Categories/IncludedLink';
import { TEAMS_PACKAGES } from '../../lib/constants';
import { SwitchAndSaveProps } from './types';
import { logAmplitudeEvent } from '../../pages/shared';
import { AMPLITUDE_PAGE_EVENTS } from '~shared/util';

export function determinePackageSwap(
  numberOfUsers: string,
  isAdvantagePackage: boolean,
  isPremierPackage: boolean,
  dispatch: React.Dispatch<CombinedActions>,
  packageName?: Packages,
  isAdvantageMonthlyCurrentlySelected = false
): void {
  let packageSwap = {};
  const userCount = Number(numberOfUsers);

  if (isAdvantagePackage) {
    if (isAdvantageMonthlyCurrentlySelected) {
      packageSwap = {
        packageToBeReplaced: PackageIds.ADVANTAGE_MONTHLY,
        replacedWith: PackageIds.TEAM_ADVANTAGE_ANNUAL,
      };
    } else if (userCount > 1) {
      packageSwap = {
        packageToBeReplaced:
          packageName && packageName === Packages.AdvantageMonthly
            ? PackageIds.ADVANTAGE_MONTHLY
            : PackageIds.ADVANTAGE_ANNUAL,
        replacedWith: PackageIds.TEAM_ADVANTAGE_ANNUAL,
      };
    } else {
      packageSwap = {
        packageToBeReplaced: PackageIds.TEAM_ADVANTAGE_ANNUAL,
        replacedWith: PackageIds.ADVANTAGE_ANNUAL,
      };
    }
    dispatch({ type: ACTIONS.SWITCH_PACKAGES, payload: packageSwap } as CombinedActions);
  }

  if (isPremierPackage) {
    if (userCount > 1) {
      packageSwap = {
        packageToBeReplaced: PackageIds.PREMIER_ANNUAL,
        replacedWith: PackageIds.TEAM_PREMIER_ANNUAL,
      };
    } else {
      packageSwap = {
        packageToBeReplaced: PackageIds.TEAM_PREMIER_ANNUAL,
        replacedWith: PackageIds.PREMIER_ANNUAL,
      };
    }
    dispatch({ type: ACTIONS.SWITCH_PACKAGES, payload: packageSwap } as CombinedActions);
  }
}

export function switchAndSave({
  numberOfUsers,
  isAdvantagePackage,
  isPremierPackage,
  pageName,
  dispatch,
  packageName,
  isAdvantageMonthlyCurrentlySelected = false,
}: SwitchAndSaveProps): void {
  determinePackageSwap(
    numberOfUsers,
    isAdvantagePackage,
    isPremierPackage,
    dispatch,
    packageName,
    isAdvantageMonthlyCurrentlySelected
  );

  dispatch({
    type: ACTIONS.PNP_REFRESH_CHANGE_USERS,
    payload: { users: numberOfUsers, packageType: isAdvantagePackage ? 'advantageUsers' : 'premierUsers' },
  } as CombinedActions);

  logAmplitudeEvent({
    eventName: 'pricing clicked Switch and Save button',
    pageName,
    amplitudeEvent: AMPLITUDE_PAGE_EVENTS.experimentEvent,
    otherData: {
      selectedPackage: isAdvantagePackage ? Packages.TeamAdvantage : Packages.TeamPremier,
      numberOfUsers,
    },
  });
}

export function getTeamCollaborationValues(packageName: Packages): boolean | React.ReactElement {
  let value: boolean | React.ReactElement = false;
  if (TEAMS_PACKAGES.includes(packageName)) {
    value = true;
  }

  if ([Packages.AdvantageAnnual, Packages.AdvantageMonthly, Packages.PremierAnnual].includes(packageName)) {
    value = <IncludedLink packageName={packageName} />;
  }

  return value;
}
